import { visitorService } from '@/shared/services/visitor';

import AmplitudeService from './amplitude.service';

const amplitudeService = new AmplitudeService(visitorService);

export { amplitudeService, type AmplitudeService };
